module.exports = __webpack_public_path__ + "static/media/book-medical.9bb8245d.svg";